export var EBackgroundTaskStatus;
(function (EBackgroundTaskStatus) {
    EBackgroundTaskStatus["PENDING"] = "PENDING";
    EBackgroundTaskStatus["STARTED"] = "STARTED";
    EBackgroundTaskStatus["WORKING"] = "WORKING";
    EBackgroundTaskStatus["ERROR"] = "ERROR";
    EBackgroundTaskStatus["FINISHED"] = "FINISHED";
})(EBackgroundTaskStatus || (EBackgroundTaskStatus = {}));
